import { keyframes } from '@emotion/react'

import { ReactComponent as HeroSVG } from '~media/certification/hero.svg'

const rotateStall = keyframes`
  0% {
      transform: rotate(0deg)

  }
   100% {
      transform: rotate(360deg)
  }
`

const AnimatedHero = () => (
  <HeroSVG
    css={{
      '& .hero_svg__greenLayer': {
        transformOrigin: 'center',
        animation: `${rotateStall} 180s infinite ease-out`,
      },

      '& .hero_svg__gremlinCertifiedText': {
        transformOrigin: 'center',
        animation: `${rotateStall} 90s reverse infinite linear`,
      },

      '& .hero_svg__centerLayer': {
        transformOrigin: 'center',
        animation: `${rotateStall} 90s infinite linear`,
      },
    }}
  />
)
export default AnimatedHero
